import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Form, Card, Checkbox, Select, TextStyle, FormLayout } from '@shopify/polaris';

import { BasicTextField } from '@presentational';
import FormPageActions from '@container/FormPageActions';
import TagsInput from 'react-tagsinput';

import Webhooks from './Webhooks';

import { tAttribute } from '@utils';

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,

  locations: PropTypes.array.isRequired,
  shopifyHooks: PropTypes.shape({
    submitURL: PropTypes.string.isRequired,
    webhooks: PropTypes.array.isRequired,
    display: PropTypes.bool,
  }).isRequired,
};


const SettingsForm = (props) => {
  const { handleChange, handleSubmit, values, errors } = props;
  return(
    <Form onSubmit={handleSubmit}>
      <Card>
        <Card.Section title={ "Configuración de Productos" }>
          <TextStyle variation="subdued">
            { I18n.t("activerecord.attributes.shop.capitalization_dictionary") }
          </TextStyle>
          <TagsInput
            value={ values.capitalization_dictionary }
            onlyUnique
            addKeys={[188, 9, 13]}
            inputProps={{
              placeholder: "de,gb,hp,etc"
            }}
            addOnPaste
            pasteSplit={
              (data) => {
                console.log("pasteSplit",data);
                return data.split(',').map(d => d.trim())
            }}
            onChange={ (data) => props.handleChange(data, "capitalization_dictionary") } />
        </Card.Section>

        <Card.Section title={ I18n.t("activerecord.models.transfer.one") }>
          <FormLayout>
            <Select
              id="apb_location_id"
              name="apb_location_id"
              label={ tAttribute("shop", "apb_location") }
              options={props.locations}
              value={ values.apb_location_id }
              onChange={ handleChange }
              error={ errors.apb_location_id }
            />
            
            <Select
              id="seller_default_location_id"
              name="seller_default_location_id"
              label={ tAttribute("shop", "seller_default_location_id") }
              options={props.locations}
              value={ values.seller_default_location_id }
              onChange={ handleChange }
              error={ errors.seller_default_location_id }
            />
          </FormLayout>
        </Card.Section>

        <Card.Section title={ I18n.t("activerecord.models.order_supply.one") }>
          <FormLayout>
            <Select
              id="order_supply_default_excluded_location_id"
              name="order_supply_default_excluded_location_id"
              label={ tAttribute("shop", "order_supply_default_excluded_location_id") }
              options={props.locations}
              value={ values.order_supply_default_excluded_location_id }
              onChange={ handleChange }
              error={ errors.order_supply_default_excluded_location_id }
            />

            {/* Hub owns the module while this is on: Seller stops emailing and cannot place POs */}
            <Checkbox
              id="order_supply_maintenance"
              name="order_supply_maintenance"
              label={ tAttribute("shop", "order_supply_maintenance") }
              helpText={ I18n.t("order_supply.maintenance.description") }
              checked={ !!values.order_supply_maintenance }
              onChange={ (checked) => handleChange(checked, "order_supply_maintenance") }
              error={ errors.order_supply_maintenance }
            />
          </FormLayout>
        </Card.Section>
          
        { props.shopifyHooks.display &&
          <Card.Section>
            <Webhooks
              webhooks={ props.shopifyHooks.webhooks}
              submitURL={ props.shopifyHooks.submitURL }
              endpointAttributeName="callbackUrl"
            />
          {/* I18n.t("shopify.webhook.topic"),
            I18n.t("shopify.webhook.created_at"),
            I18n.t("shopify.webhook.updated_at"), */}
          </Card.Section>
        }
        
      </Card>

      <FormPageActions
        onPrimaryAction={ handleSubmit }
      />
    </Form>
  )
}


SettingsForm.propTypes = propTypes;


export default SettingsForm;
